export default {"src":"/_next/static/media/slope-challenge.7e0db36b.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};